/**
 * @learnzapp/core/analytics — event catalog + DI'd helper methods.
 *
 * Platform-specific code provides the PostHog client and passes it to
 * createAnalyticsHelpers(). Phase 1: web pin (canonical). The web+mobile
 * event union is Phase 5 (events are additive).
 */
export * from './AnalyticsHelpers';
export * from './EventCatalog';
export * from './subscriptionEvents';
